export const UPSERT_STUDENT_PLACEMENT_GRADE = `
  mutation upsertStudentPlacementGrade($input: UpsertStudentPlacementGradeInput!) {
    upsertStudentPlacementGrade(input: $input) {
      platformStudentId
      placementGrade
    }
  }
`;
